<template>
  <section id="cookiePolicy" class="cookiePolicy section-show" style="height: auto!important;">
    <div class="container">

      <div>
        <h2> Политика использования Cookies </h2>
        <p>включая использование яндекс метрики</p>
        <p>в разработке</p>
      </div>

    </div>
  </section>
</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
  name: 'CookiePolicyPage',
  props: {
    serviceCode: {
      type: String,
      required: true
    }
  },
  setup: function () {
    return {}
  }
})
</script>

<style scoped>


</style>
